import type { AsyncThunk } from 'product-personalizer/src/store/hooks';

import { getEcomProxyEndpoint } from 'product-personalizer/src/utils/config';
import getCustomerReferenceId from 'product-personalizer/src/utils/getCustomerReferenceId';

import { deleteDraftAction } from '../slice';

const deleteDraftOperation =
  (designId: string): AsyncThunk =>
  async (dispatch) => {
    const customerReferenceId = getCustomerReferenceId();
    await fetch(`${getEcomProxyEndpoint()}/designs/${designId}`, {
      method: 'delete',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        customerReferenceId,
      }),
    });
    dispatch(deleteDraftAction(designId));
  };

export default deleteDraftOperation;
